import { TextLink } from "nystem-components";

const EmailLink = (props) => <TextLink {...props} />;
export default EmailLink;
